export const last_name = 'שם משפחה';
export const first_name = 'שם פרטי';
export const street = 'רחוב';
export const num = 'מספר';
export const ishuv = 'ישוב';
export const phone = 'טלפון';
export const mobilePhone = 'נייד';
export const id = 'תעודת זהות';
export const displayId = 'מספר ת.ז.';
export const colel = 'שם כולל';
export const children_num = 'מספר ילדים';
export const bankNum = 'מספר בנק';
export const bankBranchNum = 'מספר סניף';
export const bankAccount = 'מספר חשבון';
export const exists_card = 'מספר כרטיס אידיש כארד';
export const exists_card_2 = 'מספר כרטיס אידיש כארד2';
export const display_exists_card = 'אידיש כארד 1';
export const display_exists_card2 = 'אידיש כארד 2';
export const food_chain = 'רשת מזון';
export const sum = 'סכום';
export const comments = 'הערות';

export const FIELD_TO_MAX_CHARS = [
    { 'שם משפחה': 20 },
    { 'שם פרטי': 20 },
    { 'רחוב': 20 },
    { 'מספר': 4 },
    { 'ישוב': 20 },
    { 'טלפון': 10 },
    { 'נייד': 10 },
    { 'תעודת זהות': 9 },
    { 'שם כולל': 20 },
    { 'מספר ילדים': 2 },
    { 'מספר בנק': 5 },
    { 'מספר סניף': 9 },
    { 'מספר חשבון': 9 },
    { 'מספר כרטיס אידיש כארד': 11 },
    { 'מספר כרטיס אידיש כארד2': 11 },
    { 'סכום': 5 },
    { 'רשת מזון': 18 }
];

export const FIELD_TO_MIN_CHARS = [
    { 'תעודת זהות': 5 },
];

export const CSV_HEADERS = [
    last_name,
    first_name,
    street,
    num,
    ishuv,
    phone,
    mobilePhone,
    id,
    colel,
    children_num,
    bankNum,
    bankBranchNum,
    bankAccount,
    exists_card,
    exists_card_2,
    sum,
    food_chain
];

export const RESULT_CSV_HEADERS = [
    last_name,
    first_name,
    street,
    num,
    ishuv,
    phone,
    mobilePhone,
    id,
    colel,
    children_num,
    bankNum,
    bankBranchNum,
    bankAccount,
    exists_card,
    exists_card_2,
    sum,
    food_chain,
    comments
];

export const LIST_COLUMNS = [
    ishuv,
    colel,
    food_chain
];

export const REQUIRED_FIELDS = (user) => [
    last_name,
    first_name,
    street,
    num,
    ishuv,
    id,
    colel,
    children_num,
    sum, exists_card, exists_card_2,
    ...(user.foodChain == null ? [food_chain] : []),
];

export const INT_FIELDS = [
    num,
    id,
    children_num,
    bankNum,
    bankBranchNum,
    bankAccount,
    sum,
    phone,
    mobilePhone
];

export const TEXT_FIELDS = [
    food_chain, colel, ishuv
];

export const TABLE_HEADERS = [
    last_name,
    first_name,
    street,
    num,
    ishuv,
    phone,
    mobilePhone,
    displayId,
    colel,
    children_num,
    bankNum,
    bankBranchNum,
    bankAccount,
    display_exists_card,
    display_exists_card2,
    sum,
    food_chain,
    "מחיקה"
];

export const RESULT_TABLE_HEADERS = [
    last_name,
    first_name,
    street,
    num,
    ishuv,
    phone,
    mobilePhone,
    displayId,
    colel,
    children_num,
    bankNum,
    bankBranchNum,
    bankAccount,
    display_exists_card,
    display_exists_card2,
    sum,
    food_chain,
    comments
];


export const idishCardOptionA = "יש כרטיס מחלוקה קודמת";
export const idishCardOptionB = "אין כרטיס";
export const idishCard = "כרטיס אידיש כארד";
